<template>
  <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
  <v-overlay class="centered-overlay" v-model="showTemplateInput" persistent>
    <TemplatePopup @template-save="onSave" @template-back="onBack" :template="selectedTemplate"></TemplatePopup>
  </v-overlay>
  <v-container class="d-flex align-center flex-column mt-4">
    <v-btn  color="primary" @click="createTemplate">Vorlage hinzufügen</v-btn>
    <v-row class="mt-4" v-for="template in templates" :key="template.id">
      <v-col>
        <v-container class="container mb-2">
          <v-row>
            <v-col>
              <h3>{{ template.name }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-end align-center">
              <v-btn  icon @click="editTemplate(template)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="ml-1" icon @click="deleteTemplate(template)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>

</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import {useCollection, useFirestore} from "vuefire";
import {collection, query, where} from "firebase/firestore";
import WishPeriodInput from "@/components/WishPeriodInput.vue";
import TemplatePopup from "@/components/TemplatePopup.vue";
import {DeleteTemplateData, InsertTemplateData, InsertTemplateDataDates} from "@/data/templateData";
import {createDialog, notifyInfo} from "vuetify3-dialog";
import {useStore} from "@/store";

export default defineComponent({
  components: {TemplatePopup, WishPeriodInput},
  setup() {
    const db = useFirestore();
    const store = useStore();
//    const userId = store.getters.userId;
    const emplno = store.getters.emplno;
    const templates = useCollection(query( 
        collection(db, "templates"), 
        where("emplno", "==", emplno), 
    ));
    
    const isLoading = ref(false);
    
    const clickedItem = ref<number | null>(null);
    const selectedTemplate = ref(null);
    
    const showTemplateInput = ref(false);
    const createTemplate = () => {
      selectedTemplate.value = null;
      showTemplateInput.value = true;
    }

    const editTemplate = (template) => {
      // Logic to edit the period
      selectedTemplate.value = template;
      showTemplateInput.value = true;
    };

    const deleteTemplate = async (template) => {
      createDialog({ title: "Vorlage löschen",
        text: `Möchtest du die Vorlage ${template.name} wirklich löschen?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              await DeleteTemplateData(template.id);
            }
          })
    };
    
    async function onSave(template)
    {
      try{
        showTemplateInput.value = false;
        isLoading.value = true;
        await InsertTemplateData({ ...template});
        await InsertTemplateDataDates(template.id, template.inputDates);
      }
      catch(e)
      {
        console.error('Error updating document: ', e);
      }
      finally{
        notifyInfo("Die Vorlage wurde gespeichert.", {timeout: 10000, timer: true, closeOnContentClick: true}).then(() => {})
        isLoading.value = false;
      }
    }

    function onBack()
    {
      selectedTemplate.value = null;
      showTemplateInput.value = false;
    }

    return { templates, selectedTemplate, clickedItem, createTemplate, editTemplate, deleteTemplate, showTemplateInput, onBack, onSave, isLoading };
  },
});
</script>

<style scoped>
.container {
  width: 100%;
  background-color: #f0f0f0; /* Replace with your desired color */
}

.centered-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>